import React from "react";
import { T } from "../../constants/theme";

/** Resource gauge — pure inline styles, native title tooltip */
const ResourceGauge = ({ label, used, total, unit, color, loading }) => {
  const pct = Math.round((used / total) * 100);
  const alertColor = pct > 80 ? T.red : pct > 60 ? T.yellow : color;

  return (
    <div style={{ marginBottom: "12px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
        <span style={{ fontSize: "12px", fontWeight: 600, color: T.text }}>{label}</span>
        <span style={{ fontSize: "12px", fontWeight: 700, color: alertColor }}>
          {used}
          {unit} / {total}
          {unit} ({pct}%)
        </span>
      </div>
      <div
        title={`${pct}% used`}
        style={{
          display: "block",
          width: "100%",
          height: "8px",
          background: "#f1f3f5",
          borderRadius: "99px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: loading ? "0%" : `${pct}%`,
            height: "100%",
            background: alertColor,
            borderRadius: "99px",
            transition: "width 0.8s cubic-bezier(0.22,1,0.36,1)",
          }}
        />
      </div>
    </div>
  );
};

export default ResourceGauge;
